module.exports = __webpack_public_path__ + "static/media/snake_01.86dfae31.gif";